import { environment } from '@env/environment';

export const API_BASE_URL = `${environment.AWS.apiUrl.replace(/\/$/, '')}/v1`;

export const NUGGETS_URL = `${API_BASE_URL}/nuggets`;

export const TOPICS_URL = `${API_BASE_URL}/topics`;
